module.exports = __webpack_public_path__ + "img/20191011170021360截图20191011161043781.669ae0c8.jpg";